export default __webpack_public_path__ + "static/media/Course-Icons11.5f3868d1.svg";